module.exports = __webpack_public_path__ + "img/2.b17fe2cc.jpg";